import { NgModule, InjectionToken, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IContext } from '@ext-interfaces/context.model';
import { environment } from 'projects/extensions/src/environments/environment';
import { GoogleContextService } from './google-context.service';
import { MicrosoftContextService } from './microsoft-context.service';

export const CONTEXT_TOKEN = new InjectionToken('[Context]: token for context service', {
    providedIn: 'root',
    factory: function (): IContext {
        switch (environment.extension) {
            case 'chrome':
                return inject(GoogleContextService);
            case 'outlook':
                return inject(MicrosoftContextService);
            default:
                throw new Error(
                    'Context requested outside of extension environment.  Ensure that entension is of type Extension.'
                );
        }
    }
});
@NgModule({
    declarations: [],
    providers: [],
    imports: [CommonModule]
})
export class ContextModule {}
